// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3PC-0","notes":"Notes_notes__1enS3"};